import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: '[app-nav-invoices]',
  standalone: true,
  imports: [RouterLink],
  template: `
    <li>
      <button
        type="button"
        routerLink="/invoices/receipts-invoicing"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3"
        [class.active]="currentView === 'receipts-invoicing'">
        Facturación de recibos
      </button>
    </li>
    <li>
      <button
        type="button"
        routerLink="/invoices"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3"
        [class.active]="!currentView || currentView === 'dashboard'">
        Dashboard
      </button>
    </li>
    <li>
      <button
        type="button"
        routerLink="/invoices/ingresos"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3"
        [class.active]="currentView === 'invoices'">
        Ingreso
      </button>
    </li>
    <li>
      <button
        type="button"
        routerLink="/invoices/complementos"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3"
        [class.active]="currentView === 'complement'">
        Complementos
      </button>
    </li>
    <li>
      <button
        type="button"
        routerLink="/invoices/globales"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3"
        [class.active]="currentView === 'global'">
        Globales
      </button>
    </li>
    <li>
      <button
        type="button"
        routerLink="/invoices/creditnote"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3"
        [class.active]="currentView === 'credit'">
        Notas de crédito
      </button>
    </li>
    <li>
      <button
        type="button"
        routerLink="/invoices/canceladas"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3"
        [class.active]="currentView === 'canceled'">
        Canceladas
      </button>
    </li>
    <!-- Se conserva la ruta y funcionalidad para poder reactivar esta opción. -->
    <li hidden>
      <button
        type="button"
        routerLink="/invoices/generic"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3"
        [class.active]="currentView === 'generic'">
        Cargadas
      </button>
    </li>
  `,
  styles: ``
})
export class NavInvoicesComponent {
  @Input() currentView: string | null = null;
}
